export default {
  resourcePool: {
    projectAssetLibrary: '项目资产',
    publicAssetLibrary: '公共资产库',
    projectAsset: {
      addFilter: {
        title: '状态',
        added: '已添加',
        notAdded: '未添加',
      },
      bg: '背景图',
      bgm: '背景音乐',
      bgTip: '请前往全局设置编辑背景图',
      bgmTip: '请前往全局设置编辑背景音乐',
      replace: '替换资产',
      loaclUpload: '本地上传',
      fromLib: '从库里添加',
      chooseAsset: '从资产库选用',
      edit: '裁剪',
      clip: '剪辑',
      download: '下载',
      delete: '删除',
      deleteTitle: '删除已添加的资产',
      deleteContent: '删除已添加到项目中的资产，将会一并删除对应图层。',
    },
    resource: {
      uploadForbidden: {
        type: '当前模板不支持该文件格式',
        play: '玩法模板不支持该文件格式',
      },
    },
    assetLibrary: '资产库',
    myAssetLibrary: '我的资产库',
    assetTab: {
      all: '全部',
      image: '图片',
      video: '视频',
      audio: '音频',
      bgm: '背景音乐',
      sound: '音效',
      aImage: '动图',
      particle: '粒子',
    },
  },
  uoload: {
    tips: '点击上传或将文件拖动到此区域',
    subTips: {
      video: '视频文件：mp4, <{size}M',
      image: '图片文件：jpg/jpeg/png, <{size}M',
      audio: '音频文件：mp3, <{size}M',
      seq: '序列帧文件：zip(png), <{size}M',
      dragonBone: '龙骨文件：zip(json+png), <{size}M',
      seqSizeTip: '图片尺寸不一致',
      seqMaxSizeTip: '序列帧大小不能超过{size}MB',
      seqFormatTip: '序列帧文件格式不正确',
    },
  },
  upload: {
    task: {
      tips: '{num} / {total} 文件已经上传',
    },
    unsupportedFileTip: '不支持的文件类型',
    subTips: {
      unknownError: '未知错误信息',
    },
    acceptTip: '{resource}仅支持 “{accept}” 格式。以下文件无法上传：',
  },
  resource: {
    addToPlayable: {
      error: {
        seq: '当前资产不是序列帧',
        particle: '当前资产不是粒子',
        dragonBone: '当前资产不是龙骨',
        dragonBoneUnsupported: '当前模板不支持添加龙骨',
        dragonBoneFormat: '龙骨文件必需是2个json和1个png文件',
      },
    },
    category: {
      contact: '该功能仅限正式账号使用，请联系销售。',
    },
    quickLayout: {
      error: '已包含快捷布局，无法添加',
    },
    apply: {
      public: '外部',
      internal: '内部',
    },
  },
  project: {
    editingTip: '项目正在被编辑，请稍后重试',
    notexistTip: '账号下无该项目',
  },
  eventSetting: {
    warnText:
      '建议不要修改定时器相关数值，否则可能会导致互动广告无法正常试玩。',
    delayText:
      '延迟时长超过1s的跳转应用商店事件可能会被拦截，建议降低延迟时长至1s以内。',
    triggerDelayText:
      '若触发跳转应用商店事件，和用户的最后一次交互的时间间隔为1s以上，则有可能被拦截。请确认此时间间隔不会过长。',
  },
  quickToolBar: {
    eventManager: {
      title: '自定义埋点',
      sourceTips: '非当前场景的埋点无法定位',
    },
    title: '快捷定位',
  },
  textStyle: {
    update: {
      error: '更换字体失败',
    },
  },
  remindDialog: {
    content:
      '请尽量控制包体大小在对应渠道所要求的范围内！适当超出可在下载环节进行压缩，详见',
    toHelp: '帮助中心。',
    table: {
      sizeLimit: '包体大小',
      other: '其他',
    },
    ok: '我知道了',
  },
}
